export default {
  add_bank_group: "@:ui.add @:ui.bank_group",
  add_function: "@:ui.add Function",
  add_page: "@:ui.add Page",
  add_role: "@:ui.add Role",
  add_user: "@:ui.add User",
  edit_function: "@:ui.edit Function",
  edit_page: "@:ui.edit Page",
  edit_role: "@:ui.edit Role",
  edit_user: "@:ui.edit User",
  edit_account: "@:ui.edit Account",
  edit_password: "@:ui.edit @:ui.password",
  edit_provider: "@:ui.edit @:ui.game_provider",
  delete_function: "@:ui.delete Function",
  delete_page: "@:ui.delete Page",
  delete_role: "@:ui.delete Role",
  delete_user: "@:ui.delete User",
  assign_functions: "@:ui.assign Functions",
  assign_roles: "@:ui.assign Roles",
  confirm_password: "Confirm @:ui.password",
  change_password: "Change @:ui.password",
  old_password: "Old @:ui.password",
  new_password: "@:ui.new @:ui.password",
  account_status: "@:ui.account @:ui.status",
  account_settings: "@:ui.account @:ui.settings",
  layout_settings: "@:ui.layout @:ui.settings",
  add_account: "@:ui.add @:ui.account",
  edit_currency: "@:ui.edit @:ui.currency",

  add_ip: "@:ui.add IP",
  delete_ip: "@:ui.delete IP",

  reset_password: "@:ui.reset @:ui.password",
  edit_profile: "@:ui.edit @:ui.profile",
  edit_authority: "@:ui.edit @:ui.authority",
  edit_bet_limit: "@:ui.edit @:ui.bet_limit",
  update_commission: "@:ui.update @:ui.commission",
  update_bet_limit: "@:ui.update @:ui.bet_limit",
  update_position_taking: "@:ui.update @:ui.position_taking",
  update_profile: "@:ui.update @:ui.profile",
  edit_platform: "@:ui.edit @:ui.platform",
  manual_process_statement: "Process Statement (Manual)",
  add_tournament_op: "Add Tournament Operator",

  close: "Close",
  ok: "OK",
  cancel: "Cancel",
  apply: "Apply",
  login: "Login",
  logout: "Logout",
  add: "Add",
  edit: "Edit",
  delete: "Delete",
  refresh: "Refresh",
  assign: "Assign",
  action: "Action",
  id: "ID",
  name: "Name",
  all: "All",
  search: "Search",
  remove: "Remove",
  save: "Save",
  load: "Load",
  account: "Account",
  settings: "Settings",
  reset: "Reset",
  on: "ON",
  off: "OFF",
  new: "New",
  bet: "Bet",
  clear: "Clear",
  system: "System",
  functions: "Function | Functions",
  pages: "Page | Pages",
  roles: "Role | Roles",
  users: "User | Users",
  overview: "Overview",
  iplist: "IP Whitelist",
  username: "Username",
  password: "Password",
  created_on: "Create On",
  active: "Active",
  disabled: "Disabled",
  blocked: "Blocked",
  suspended: "Suspended",
  page_size: "Page Size",
  no_data: "No Data Available",
  status: "Status",
  login_attempt: "Login Attempt",
  user_roles: "Roles",
  layout: "Layout",

  today: "Today",
  yesterday: "Yesterday",
  thisweek: "This Week",
  lastweek: "Last Week",
  thismonth: "This Month",
  lastmonth: "Last Month",
  last3month: "Last 3 Months",

  // company related
  company: "Company",
  share_holder: "Share Holder",
  super_senior: "Super Senior",
  senior: "Senior",
  master: "Master",
  agent: "Agent",
  member: "Member",

  add_secondary_full: "Add Secondary Account",
  add_account: "Add Account",
  account_id: "Account ID",
  amount: "Amount",
  action_by: "Action By",
  add_sub: "Add Sub-account",
  audit_by: "Audit By",
  authority_option: "Authority Option",
  account_type: "Account Type",
  account_unblock: "Account Unblock",
  add_secondary: "Add Secondary Account",
  accumulate_win: "Accumulated Win",
  abandoned: "Abandoned",
  after_balance: "After Balance",
  before_balance: "Before Balance",
  back: "Back",
  bet_type: "Bet Type",
  bet_limit: "Bet Limit",
  bet_count: "Bet Count",
  bet_limit_packages: "Bet Limit Packages",
  browser_agent: "Browser Agent",
  category: "Category",
  commission: "Commission",
  closed: "Closed",
  copy: "Copy",
  cash: "Cash",
  credit: "Credit",
  cash_mode: "Cash Mode",
  confirm_password: "Confirm Password",
  contact_phone: "Contact Phone",
  contact_email: "Contact Email",
  currency: "Currency",
  credit_limit: "Credit Limit",
  copy_to_bottom: "Copy to Bottom",
  current_balance: "Current Balance",
  balance: "Balance",
  completed: "Completed",
  currency_code: "Currency Code",
  created_by: "Create By",
  deposit: "Deposit",
  draw: "Draw",
  details: "Details",
  date: "Date",
  detail: "Detail",
  date_time: "Date/Time",
  daily_reset: "Daily Reset",
  downline_limit: "Downline Limit",
  event: "Event",
  even: "Even",
  enable: "Enable",
  edit_account: "Edit Account",
  failed: "Failed",
  freezed: "Freezed",
  full_mode: "Full Mode",
  full_name: "Full Name",
  gross_winlose: "Gross Winlose",
  grand_total: "Grand Total",
  gross_commission: "Gross Commission",
  game_name: "Game Name",
  game_provider: "Game Provider",
  ip_address: "IP Address",
  jackpot: "Jackpot",
  keno: "Keno",
  lose: "Lose",
  lose_half: "Lose Half",
  league: "League",
  last_goal: "Last Goal",
  league_name: "League Name",
  league_id: "League ID",
  login_ip: "Login IP",
  livecasino: "Live Casino",
  login_id: "Login ID",
  lotto: "Lotto",
  lottery: "Lottery",
  lottery_1d: "Lottery 1D",
  lottery_2d: "Lottery 2D",
  lottery_3d: "Lottery 3D",
  lottery_4d: "Lottery 4D",
  last_login: "Last Login Date/Time",
  last_login_ip: "Last Login IP",
  match: "Match",
  match_id: "Match ID",
  member_id: "Member ID",
  money_line: "Money Line",
  member_credit_limit: "Member Credit Limit",
  min: "Min",
  max: "Max",
  min_bet: "Min Bet",
  max_bet: "Max Bet",
  max_per_match: "Max Per Match",
  mix_parlay: "Mix Parlay",
  match_time: "Match Time",
  member_bulk: "Member Bulk",
  modified_date: "Modified Date/Time",
  new_login_id: "New Login ID",
  new_password: "New Password",
  product: "Product",
  pending_matches: "Pending Matches",
  pending: "Pending",
  platform: "Platform",
  payout: "Payout",
  profile: "Profile",
  payment_option: "Payment Options",
  pay: "Pay | Pay All",
  platform_code: "Platform Code",
  parent_id: "Parent ID",
  profile_id: "Profile ID",
  password_reset: "Password Reset",
  password_update: "Password Update",
  platform_name: "Platform Name",
  remark: "Remark",
  remaining_credit: "Remaining Credit",
  remaining: "Remaining",
  rate: "Rate",
  reject: "Reject",
  refund: "Refund",
  reset_accumulate_win: "Reset Accumulated Win",
  result: "Result",
  running: "Running",
  running_score: "Running Score",
  sport_type: "Sport Type",
  succeed: "Succeed",
  settings_limit: "Settings Limit",
  sportsbook: "Sportsbook",
  slot_games: "Slot Games",
  slots: "Slots",
  sport_types: "Sport Types",
  soccer: "Soccer",
  system_type: "System Type",
  sub_total: "Sub Total",
  settlement: "Settlement",
  settle_amount: "Transfer Amount",
  set_authority: "Set Authority",
  status_update: "Update Status",
  security_update: "Update Security",
  security_tag: "Security Tag",
  security_code: "Security Code",
  security_disable: "Security Disabled",
  settlement_agent_bulk: "Settlement Agent Bulk",
  settlement_agent: "Settlement Agent",
  settle_agent: "Settlement Agent",
  settlement_member_bulk: "Settlement Member Bulk",
  settlement_member: "Settlement Member",
  settle_member: "Settlement Member",
  system_id: "System ID",
  sports_type: "Sports Type",
  total: "Total",
  turnover: "Turnover",
  types: "Types",
  target_id: "Target ID",
  target_action: "Target Action",
  transaction_date: "Transaction Date",
  transfer_method: "Transfer Method",
  transfer: "Transfer",
  tournament: "Tournament",
  under: "Under",
  update_platform: "Update Platform",
  update_account: "Update Account",
  block: "Block",
  unblock: "Unblock",
  unblock_profile: "Profile Unblock",
  update_cashmode: "Update Cash Mode",
  valid_turnover: "Valid Turnover",
  void: "Void",
  vip: "VIP",
  wm: "WM%",
  wm_nl: "WM% (N)",
  wm_live: "WM% (L)",
  win: "Win",
  won: "Won",
  win_half: "Won Half",
  winlose: "Winlose",
  winlose_column1: "W/L",
  winlose_column2: "Comm",
  win_limit_multiplier: "Win limit Multiplier",
  win_limit: "Win Limit",
  withdrawal: "Withdrawal",
  yesterday_balance: "Yesterday Balance",
  unblock_account: "Unblock Account",
  account_sub_list: "Sub Account List",
  account_sub_id: "Sub Account ID",
  account_freeze: "Single Layer Freeze",
  account_block: "Blocked Account",

  type: "Type",
  minBet: "Min. Bet",
  maxBet: "Max. Bet",
  maxPerMatch: "Max/Match",
  range: "Range",
  package: "Package",
  error: "Error",
  portion: "Share",
  ticket: "Ticket",
  rejected: "Rejected",
  processed: "Processed",
  bank: "Bank",
  info: "Info",
  approve: "Approve",
  attachment: "Attachment",
  approveTicket: "Approve Ticket",
  rejectTicket: "Reject Ticket",
  ticket_id: "Ticket ID",
  ref_no: "Ref. No",
  bank_acc_no: "Bank Account",
  bank_acc_holder: "Account Holder",
  bank_name: "Bank Name",
  time: "Time",
  home: "Home",
  away: "Away",
  earning: "Earning",
  bank: "Bank",
  bank_group: "Bank Group",
  bank_operator: "Company Bank",
  bank_member: "Member Bank",
  group_id: "Group ID",
  group_name: "Group Name",
  is_default: "Is Default",
  created_date: "Creation Date",
  edit_bank_group: "Edit Bank Group",
  edit_bank_account_group: "Edit Bank Account Group",
  set_default: "Set Default",
  available_bank_account: "Available Bank Account",
  group_bank_account: "Group Bank Account",
  edit_bank_member: "Edit Member Bank",
  add_bank_account: "Add Bank Account",
  configure_bank_setting: "Configurate Bank Setting",
  bank_transfer: "Bank Transfer",
  inactive: "Inactive",
  both: "Both",
  incoming: "Incoming",
  outgoing: "Outgoing",

  short: {
    provider_status: "P.Status",
    own_status: "O.Status",
    deposit_amount: "Dep Amt",
    base_amount: "Base Amt",
    bonus_amount: "Bonus Amt",
    target_amount: "Trgt Amt",
    accumulate_win: "Acc Win",
    accumulate_turnover: "Acc TO",
    accumulate_amount: "Acc Amt",
    knockoff_by: "K.O By",
    knockoff_date: "K.O Date",
    incoming_amount_threshold: "INC AMT TH",
    accumulate_incoming_amount: "ACCUM INC AMT",
    incoming_frequency_threshold: "INC AMT FRQ",
    accumulate_incoming_frequency: "ACCUM INC FRQ",
    outgoing_amount_threshold: "OG AMT TH",
    accumulate_outgoing_amount: "ACCUM OG AMT",
    outgoing_frequency_threshold: "OG AMT FRQ",
    accumulate_outgoing_frequency: "ACCUM OG FRQ",
    incoming_threshold: "IN THRES",
    incoming_frequency: "IN FREQ",
    outgoing_threshold: "OUT THRES",
    outgoing_frequency: "OUT FREQ",
    account_balance: "ACC BAL",
    promotion_id: "P.ID",
    promotion_name: "P.Name",
    claim_type: "C.Type",
    min_deposit: "M.Deposit",
    bonus_rate: "B.Rate",
    max_bonus: "M.Bonus",
    rollover: "Rollover",
    criteria: "Criteria",
    withhold_bonus: "W.Bonus",
    withhold_amount: "W.Amt",
    max_withdraw_amount: "M.W.Amt",
    start_date: "S.Date",
    end_date: "E.Date",
    start_time: "S.Time",
    end_time: "E.Time",
    monday: "MON",
    tuesday: "TUE",
    wednesday: "WED",
    thursday: "THU",
    friday: "FRI",
    saturday: "SAT",
    sunday: "SUN",
    status: "Status",
    bonus_rate_percent: "B.Rate (%)",
    referee_count_confirm: "R.C.C",
    provider_list: "P.List",
    valid_turnover: "V.Turnover",
    deposit_amount: "Dep Amt",
    deposit_count: "Dep Cnt",
    withdrawal_amount: "Wdw Amt",
    withdrawal_count: "Wdw Cnt",
    bonus_amount: "Bonus Amt",
    adjustment_amount: "Adj Amt",
    referee_count: "Referee Cnt",
    signup_count: "Signup Cnt",
    verified_count: "VRF Count",
    active_member: "Active Mbm",
    ftd_count: "FTD Cnt",
    ftd_amount: "FTD Amt",
    working_date: "Wrking DT",
    bet_count: "Bet Cnt",
    bank_acc_holder: "Acc Holder",
    bank_acc_no: "Acc No",
    bank_acc_type: "Acc Type"
  },

  closing: "Closing",
  debit: "Debit",
  referer: "Referer",
  reset_threshold: "Reset Threshold",
  bank_adjust: "Bank Adjustment",
  edit_bank_account: "Edit Bank Account",
  bank_acc_type: "Account Type",
  account_balance: "Account Balance",
  threshold: "Threshold",
  frequency: "Frequency",
  is_public: "Is Public",
  adjust_amount: "Adjust Amount",
  mode: "Mode",
  bank_from: "Bank From",
  bank_to: "Bank To",
  accumulate_incoming_amount: "Accum In. Amt",
  accumulate_outgoing_amount: "Accum Out. Amt",
  get_bank_tac: "Get Bank TAC",
  ticket_deposit_manual: "Manual Ticket Deposit",
  ticket_list: "Ticket List",
  pending_ticket: "Pending Ticket",
  alert: "Alert",
  selected: "selected field",
  selected_bank: "Selected Bank",
  old_value: "Old Value",
  new_value: "New Value",
  client_ip: "Client IP",
  profile_status: "Profile Status",
  log: "Log",
  receipt: "Receipt",
  upload: "Upload",
  attachment_path: "Attachment URL",
  redeposit: "Redeposit",
  tac: "TAC",
  tac_expiry: "TAC Expiry",
  fee: "Fee",
  refer_account_id: "Referrer Account ID",
  activated_date: "Activated Date",
  member_tac_activate: "Member TAC Activate",
  activate: "Activate",
  agent_id: "Agent ID",
  adjustment: "Adjustment",
  description: "Description",
  totalMember: "Total Member",
  totalMemberLogin: "Total Member Login",
  totalMemberRegister: "Total Member Register",
  totalActiveMember: "Total Active Member",
  totalFirstDepositMember: "Total First Deposit Member",
  totalDeposit: "Total Deposit",
  totalDepositTransaction: "Total Deposit Transaction",
  averageDeposit: "Average Deposit",
  uniqueDepositMember: "Unique Deposit Member",
  totalFirstWithdrawalMember: "Total First Withdrawal Member",
  totalWithdrawal: "Total Withdrawal",
  totalWithdrawalTransaction: "Total Withdrawal Transaction",
  averageWithdrawal: "Average Withdrawal",
  uniqueWithdrawalMember: "Unique Withdrawal Member",
  totalAdjustment: "Total Adjustment",
  totalAdjustmentMember: "Total Adjustment Member",
  averageAdjustment: "Average Adjustment",
  totalAgentWithdrawalTransaction: "Total Agent Withdrawal Transaction",
  totalAgentTransferTransaction: "Total Agent Transfer Transaction",
  totalAgentTransfer: "Total Agent Transfer",
  totalAgentWithdrawal: "Total Agent Withdrawal"
};
